import React from 'react'
import BannerImg from '../../../assets/images/Andorra Company Formation-banner.png'
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import SEO from "../../../utils/SEO";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import IntroSection from "../../../components/IntroSection/IntroSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";

function CompanyFormationAndorra() {
    return (
        <main className='main'>

            <SEO
                title="Andorra Company Formation | Offshore Company Setup & Services"
                description="Professional offshore company formation in Andorra. Get expert services for registration, documents, bank accounts, and corporate setup."
                keywords="Andorra company formation, offshore company formation, company formation, company incorporation, company formation documents, company registration, business formation types, company formation law, company formation bank account, company formation charges, company formation process, company formation services, company formation agent, company formation online, company formation guide, company formation experts, company formation for non residents, company formation for foreigners, corporate formation, quality company formation"
                url="/company-formation-andorra"
            />

                <section className='section'>
                <IntroSection
                    title="Andorra Company Formation | Offshore Advisory"
                    description=
                        {
                            `
                    Professional offshore company formation in Andorra is your gateway to establishing a business in a stable, tax-friendly jurisdiction. Offshore Advisory provides expert guidance to entrepreneurs and international investors looking to take advantage of Andorra’s attractive corporate environment.
                    <br/>
                    <br/>
                    With low corporate tax rates, a strong legal framework, and business-friendly regulations, Andorra is one of Europe’s most appealing destinations for startups, international investors, and holding companies. Our team ensures a smooth, compliant, and efficient company formation process, whether you are a resident or a non-resident.
                    <br/>
                    <br/>
                    `}
                    imageSrc={require('../../../assets/images/Andorra Company Formation-hero.png')}
                    buttonText="Request a Andorra Golden Visa Consultation →"
                    buttonLink="/quote"
                    imageAlt="Andorra Golden Visa & Residency"
                />

                <div className='container'>
                    <InfoBlocks
                        title='Why Choose Andorra?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Strategic Location",
                                        text: "Situated between Spain and France, Andorra provides easy access to the European market.",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Low Taxes",
                                        text: "Enjoy some of Europe’s lowest corporate tax rates.",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Strong Legal Protection",
                                        text: "Comprehensive laws safeguard your assets and business operations.",
                                        icon: TiTick,
                                    },
                                    {
                                        title: "Business-Friendly Environment",
                                        text: "Minimal bureaucracy allows startups and international businesses to operate efficiently.",
                                        icon: TiTick,
                                    }
                                ]
                            }
                        ]}
                    />

                    <br/><br/>

                    <h1 className='page-title'>Our Services & Step-by-Step Formation Process</h1>
                    <p className='page-paragraph'>
                        At Offshore Advisory, we provide end-to-end support for establishing your company in Andorra. From the first consultation to ongoing compliance, our services are designed to make the process smooth, efficient, and fully compliant.
                    </p>

                    <strong>Here’s how we help you at every stage:</strong>

                    <h2 className='page-subtitle'>
                        1. Consultation & Planning
                    </h2>
                    <p>We start by understanding your business objectives and requirements.</p>
                    <WhySection
                        title="What we do:"
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Assess your business model, goals, and target market",
                                        icon: GoDotFill,
                                    },
                                    {
                                        text: "Advise on optimal company structures and strategies",
                                        icon: GoDotFill,
                                    },
                                    {
                                        text: "Outline the steps and timelines for formation",
                                        icon: GoDotFill,
                                    },
                                ]
                            }
                        ]}
                    />
                    <BannerPageImg src={BannerImg}/>

                    <h2 className='page-title'>2. Company Registration & Structure Selection</h2>
                    <p className='page-paragraph'>
                        We guide you in choosing the right type of company (Sociedad Limitada, Sociedad Anónima, or Branch Office) and complete registration efficiently.
                    </p>

                    <WhySection
                        title="Our support includes:"
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Comparing company types based on liability, capital requirements, and flexibility",
                                        icon: GoDotFill,
                                    },
                                    {
                                        text: "Preparing and submitting registration applications",
                                        icon: GoDotFill,
                                    },
                                    {
                                        text: "Coordinating with authorities to expedite approval",
                                        icon: GoDotFill,
                                    },
                                ]
                            }
                        ]}
                    />

                    <h2 className='page-title'>3. Corporate Documentation</h2>
                    <p>
                        Proper documentation ensures your company is legally protected from day one.
                    </p>
                    <WhySection
                        title="Our services cover:"
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Drafting Articles of Association tailored to your business",
                                        icon: GoDotFill,
                                    },
                                    {
                                        text: "Preparing Shareholder Agreements and statutory forms",
                                        icon: GoDotFill,
                                    },
                                    {
                                        text: "Ensuring all documents comply with Andorran law",
                                        icon: GoDotFill,
                                    },
                                ]
                            }
                        ]}
                    />

                    <h2 className='page-title'>4. Bank Account Setup & Licensing</h2>

                    <WhySection
                        title="Offshore Advisory helps you establish operational readiness by handling banking and permits:"
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Recommending banks and preparing documentation for corporate accounts",
                                        icon: GoDotFill,
                                    },
                                    {
                                        text: "Obtaining necessary licenses and permits for your business type",
                                        icon: GoDotFill,
                                    },
                                    {
                                        text: "Liaising with authorities to ensure timely approvals",
                                        icon: GoDotFill,
                                    },
                                ],
                            },
                        ]}
                    />

                    <h2 className='page-title'>5. Ongoing Compliance & Reporting</h2>
                    <h3 className='page-paragraph'>
                        After your company is operational, we provide continuous compliance support to maintain legal standing:
                    </h3>

                    <WhySection
                        title="After your company is operational, we provide continuous compliance support to maintain legal standing:"
                        blocks={[
                            {
                                items: [
                                    {
                                        text: "Advising on corporate governance and statutory reporting",
                                    },
                                    {
                                        text: "Assisting with bookkeeping and financial records",
                                    },
                                    {
                                        text: "Ensuring adherence to tax obligations and regulatory requirements",},
                                    {
                                        text: "Updating you on relevant law changes affecting your business",
                                    }
                                ],
                            },
                        ]}
                    />

                    <DetailsSection
                        title="Why This Approach Matters"
                        subtitle='
                                                By combining our expert services with a clear step-by-step process, Offshore Advisory ensures that your Andorra company formation is:
                        '
                        items={
                            [
                                {
                                    title: "Efficient",
                                    text: "No unnecessary delays or complications",
                                },
                                {
                                    title: "Legally Compliant",
                                    text: "Every step follows Andorran law",
                                },
                                {
                                    title: "Transparent",
                                    text: "You know exactly what happens at each stage",
                                },
                                {
                                    title: "Growth-Ready",
                                    text: "Your company is structured for long-term success",
                                },
                            ]
                        }
                    />

                    <div className='flex-start'>
                        <WhySection
                            title='Types of Companies in Andorra'
                            blocks={[
                                {
                                    items:
                                        [
                                            {
                                                title: "Sociedad Limitada (SL) ",
                                                paragraph: "Limited liability company suitable for small to medium enterprises.",
                                            },
                                            {
                                                title: "Sociedad Anónima (SA)",
                                                paragraph: "Public limited company ideal for larger investors.",
                                            },
                                            {
                                                title: "Branch Office",
                                                paragraph: "Extension of a foreign company operating in Andorra.",
                                            },
                                        ]
                                }
                            ]}
                        />

                        <WhySection
                        title='Who Can Benefit?'
                        subtitle='Operating a brokerage without a license limits your growth and credibility. With a license, you gain:'
                        blocks={[
                            {
                                items:
                                    [
                                        { title: "Residents and Non-Residents", text: "Formation support for individuals regardless of location." },
                                        { title: "Entrepreneurs & Startups", text: " Fast and simple setup for new businesses." },
                                        { title: "International Investors & Holding Companies", text: "Access tax benefits, asset protection, and flexible ownership rules." },
                                    ]
                            }
                        ]}
                        end="Forming a company in Andorra gives you an internationally attractive business environment with strong growth potential."
                        />
                    </div>

                    <Testimonials title='Client Testimonials' testimonials={testimonialsData}/>

                    <FAQList title='Frequently Asked Questions (FAQ)' data={faqData} />

                    <CTA
                        title="Contact Offshore Advisory Today!"
                        description=
                            "Ready to form your company in Andorra? Offshore Advisory makes the process simple, fast, and fully compliant."
                        buttonText="Book a Andorra Company Formation Consultation Today →"
                        buttonLink="/consultation"
                    />

                </div>
            </section>
        </main>
    )
}

export default CompanyFormationAndorra


const testimonialsData = [
    {
        quote:
            "Offshore Advisory helped me set up my Andorra-based company from start to finish. Their team guided me through registration, banking, and compliance effortlessly.",
        author: "David P.",
        role: "International Investor",
    },
    {
        quote:
            "As a startup founder, I appreciated the step-by-step support and quick turnaround provided by Offshore Advisory. Now my business is operating efficiently in Europe!",
        author: "Elena R.",
        role: "Entrepreneur",
    },
];

const faqData = [
    {
        question: "Can non-residents form a company in Andorra?",
        answer: "Yes, Andorra allows non-residents to establish companies with full support from Offshore Advisory."
    },
    {
        question: "How long does registration take?",
        answer: "Typically 2–4 weeks, depending on company type and document readiness."
    },
    {
        question: "Do I need to be present in Andorra?",
        answer: "No. Offshore Advisory can handle most steps remotely."
    },
    {
        question: "What are the costs involved?",
        answer: "Costs vary based on company type and services but are transparent and discussed upfront."
    },
    {
        question: "What taxes will my company pay?",
        answer: "Corporate tax rates start at 10%, with additional incentives for international businesses."
    },

];
